import http from "./HttpService";

const endpoint = process.env.VUE_APP_CONFIG_MANAGEMENT_URL + "/api/admin/";

export const getConfigs = () => {
  return http.get("app/upgrade-versions", {
    baseURL: endpoint,
  });
};

export const updateConfigs = (data) => {
  return http.put("app/upgrade-versions", data, {
    baseURL: endpoint,
  });
};
